import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param attachmentId
 * @param tenantSellerId
 * @param status
 * @param page
 * @param limit
 * @param searchKeyword
 * @param entityId
 * @param entityName
 * @param poId
 */
class AttachmentServices {
    /**
     *
     * @param {*} payload
     * @return
     */
    createAttachment = async (payload) => {
      const attachment = await Helpers.post({
        url: Constants.ATTACHMENT,
        data: payload,
      });
      return attachment;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
     updateAttachment = async (payload) => {
       const attachment = await Helpers.put({
         url: Constants.ATTACHMENT,
         data: payload,
       });
       return attachment;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
      deleteAttachment = async (payload) => {
        const attachment = await Helpers.delete({
          url: Constants.ATTACHMENT,
          data: payload,
        });
        return attachment;
      }

    getAttachment = async (entityId, entityName) => {
      let url = `${Constants.ATTACHMENT}?`;
      if (entityId) url += `entity_id=${entityId}&`;
      if (entityName) url += `entity_name=${entityName}&`;

      const attachment = await Helpers.get({ url });
      return attachment;
    }
}
export default new AttachmentServices();
